// İLK SATIR OLARAK KALMALI: zod'un eval yoklamasını, zod'la ilk ayrıştırmadan önce kapatır (CSP).
import "@/lib/zod-jitless";
import "@/lib/forms/zod-turkish";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles/app.css";
import { App } from "@/app/App";
import { disableBrowserAutofill } from "@/lib/forms/autofill-off";

const container = document.getElementById("root");
if (!container) throw new Error("#root bulunamadı — index.html bozulmuş.");

// Tarayıcının otomatik doldurması sistem genelinde kapalı (30 Ekim 2026, `autofill-off.ts`).
disableBrowserAutofill();

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
